import { IFieldSubmissionMap, IFormFieldSubmission } from "@common/redux/formSubmission/interface";
import { IFieldRuleConfig } from "@presentation/FormBuilder/Rules/config";
import { validateSubRule } from "@presentation/FormBuilder/utils";
import { FieldProps } from "../../FormFieldSelector/interfaces";
export const validateLinearScaleFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission,
  fieldSubmissionMap: IFieldSubmissionMap
): [boolean, string] => {
  const { isRequired, rules: fieldRules, isVisible} = fieldEditConfig;
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;

  const { selectedOption } = fieldSubmissionValue;

  if (isRequired && !!isVisible) {
    if (!selectedOption && selectedOption !== 0) {
      return [false, "This is a Required Field"];
    }
  }
  if (fieldRules) {
    for (let i = 0; i < fieldRules.length; i++) {
      const [isValidated, validatationErrorMessage] = validationRule(
        fieldRules[i],
        selectedOption,
        fieldSubmissionMap
      );

      if (!isValidated && validatationErrorMessage != "") {
        return [isValidated, validatationErrorMessage];

        break;
      }
    }
  }

  return [true, ""];
};

export const validationRule  = (
  fieldRule: IFieldRuleConfig,
  submissionValue: any,
  fieldSubmissionMap: IFieldSubmissionMap
): [boolean, string] => {
  const {rule, value, errorMessage, subRules} = fieldRule;
  const ruleType: string = rule;
  const ruleValue: any = value;
  const ruleErrorValue: string = errorMessage;

  switch (ruleType) {
    case "TEXT_EQUAL":
      if (ruleValue != submissionValue)
        return [false, ruleErrorValue];

      break;
    default:
      break;
  }

  if(subRules?.length > 0 ){
    const [isValidated, validatationErrorMessage] = validateSubRule(fieldRule, submissionValue, fieldSubmissionMap, validationRule);
    return [isValidated, validatationErrorMessage];
  }
  
  return [true, ""];
};
